var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0096 6.35212C12.0096 9.44302 9.49212 11.9542 6.37979 11.9542C3.26747 11.9542 0.75 9.44302 0.75 6.35212C0.75 3.26123 3.26747 0.75 6.37979 0.75C9.49212 0.75 12.0096 3.26123 12.0096 6.35212Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4473 10.4015L13.3285 13.68",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.f3eaa6f50831d83fd8e29ed116297e6e.svg";
export { ForwardRef as ReactComponent };